import { useEffect, useState } from 'react';
import SidePanel from '../../components/SidePanel';
import Dropdown from '../../components/receptura/Dropdown';

const TYPY_HLAVNI = [
    ['vklad_majitel', 'Vklad CEO (+)'],
    ['vyber_majitel', 'Výběr CEO (-)'],
    ['prevod_z_banky', 'Převod z banky (+)'],
    ['odvod_do_banky', 'Odvod do banky (-)'],
    ['zaloha_mzdy', 'Záloha mzdy (-)'],
    ['hotovostni_vydaj', 'Hotovostní výdaj s dokladem (-)'],
    ['osobni_odber_zamestnanec', 'Osobní odběr zaměstnance (+)'],
    ['vyplata_z_hlavniho', 'Výplata z hlavního (-)'],
];
const TYPY_ROZVOZ = [
    ['prijem_hotovost', 'Příjem hotovosti (+)'],
    ['hotovostni_vydaj', 'Hotovostní výdaj (-)'],
];

export default function PridatPohybModal({ smena, isDark, onClose, onSaved }) {
    const isHlavni = smena?.pokladna?.typ === 'bistro_hlavni';
    const typy = isHlavni ? TYPY_HLAVNI : TYPY_ROZVOZ;

    const [typ, setTyp] = useState(typy[0][0]);
    const [castka, setCastka] = useState('');
    const [zamestnanecId, setZamestnanecId] = useState('');
    const [poznamka, setPoznamka] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [zamestnanci, setZamestnanci] = useState([]);
    const [isMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth < 768);

    useEffect(() => {
        if (typ === 'zaloha_mzdy' || typ === 'osobni_odber_zamestnanec') {
            fetch('/api/zamestnanci', { credentials: 'same-origin' })
                .then(r => r.ok ? r.json() : [])
                .then(d => setZamestnanci(Array.isArray(d) ? d : (d?.data ?? [])))
                .catch(() => {});
        }
    }, [typ]);

    const token = document.querySelector('meta[name="csrf-token"]')?.content;

    const handleSubmit = async () => {
        if (!castka || Number(castka) <= 0) {
            alert('Zadej částku.');
            return;
        }
        setSubmitting(true);
        try {
            const r = await fetch(`/api/finance/pokladna/smeny/${smena.id}/pohyb`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': token },
                credentials: 'same-origin',
                body: JSON.stringify({
                    typ,
                    castka_kc: Number(castka),
                    zamestnanec_id: zamestnanecId ? Number(zamestnanecId) : null,
                    poznamka: poznamka || null,
                }),
            });
            if (!r.ok) throw new Error(await r.text());
            onSaved?.();
        } catch (e) { alert('Uložení selhalo: ' + e.message); }
        setSubmitting(false);
    };

    const showZamestnanec = ['zaloha_mzdy', 'osobni_odber_zamestnanec'].includes(typ);

    return (
        <SidePanel open={true} onClose={onClose} title={`Přidat pohyb — ${smena?.pokladna?.nazev ?? ''}`} isDark={isDark} isMobile={isMobile} width={460} modal={true}
            footer={
                <div className="flex gap-2">
                    <button onClick={onClose} className="px-4 py-2 rounded-lg text-sm" style={{ color: 'var(--text-secondary)' }}>Zrušit</button>
                    <button onClick={handleSubmit} disabled={submitting} className="flex-1 py-2 rounded-lg text-sm font-medium text-white" style={{ background: '#3B82F6', opacity: submitting ? 0.5 : 1 }}>
                        {submitting ? 'Ukládám…' : 'Uložit pohyb'}
                    </button>
                </div>
            }
        >
            <div className="p-5 space-y-3">
                <Field label="Typ pohybu">
                    <Dropdown value={typ} onChange={v => setTyp(v)}
                        options={typy.map(([v, l]) => ({ value: v, label: l }))}
                        isDark={isDark} accent="#3B82F6" height={38} />
                </Field>
                <Field label="Částka (Kč)">
                    <input type="number" step="0.01" min="0.01" value={castka} onChange={e => setCastka(e.target.value)} placeholder="0.00"
                        className="w-full rounded p-2 text-sm"
                        style={{ background: 'var(--surface-base)', color: 'var(--text-primary)', border: '1px solid var(--border-default)' }} />
                </Field>
                {showZamestnanec && (
                    <Field label="Zaměstnanec">
                        <input type="number" placeholder="ID zaměstnance" value={zamestnanecId} onChange={e => setZamestnanecId(e.target.value)}
                            className="w-full rounded p-2 text-sm"
                            style={{ background: 'var(--surface-base)', color: 'var(--text-primary)', border: '1px solid var(--border-default)' }} />
                    </Field>
                )}
                <Field label="Poznámka">
                    <textarea value={poznamka} onChange={e => setPoznamka(e.target.value)} placeholder="Volitelně…"
                        className="w-full rounded p-2 text-sm" style={{ background: 'var(--surface-base)', color: 'var(--text-primary)', border: '1px solid var(--border-default)', minHeight: 80 }} />
                </Field>
            </div>
        </SidePanel>
    );
}

function Field({ label, children }) {
    return (
        <div>
            <label className="text-xs font-medium mb-1 block" style={{ color: 'var(--text-secondary)' }}>{label}</label>
            {children}
        </div>
    );
}
